export const categories = [
  {
    slug: 'lifestyle',
    name: '生活',
    icon: 'ri-home-heart-line',
    description: '记录日常美好，分享品质生活点滴',
    imageQuery: 'warm%20cozy%20modern%20living%20room%20with%20soft%20natural%20lighting%2C%20scandinavian%20interior%20design%2C%20minimalist%20aesthetic%2C%20neutral%20warm%20tones%2C%20editorial%20photography%2C%20clean%20composition',
  },
  {
    slug: 'entertainment',
    name: '娱乐',
    icon: 'ri-movie-2-line',
    description: '最新最热的娱乐资讯与精彩节目',
    imageQuery: 'colorful%20vibrant%20concert%20stage%20with%20dynamic%20lighting%2C%20music%20performance%20atmosphere%2C%20energetic%20crowd%2C%20warm%20golden%20and%20pink%20tones%2C%20editorial%20photography%2C%20soft%20focus',
  },
  {
    slug: 'food',
    name: '美食',
    icon: 'ri-restaurant-2-line',
    description: '探索舌尖上的美味，发现烹饪的乐趣',
    imageQuery: 'elegant%20gourmet%20food%20photography%20on%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20artisanal%20cuisine%20presentation%2C%20natural%20textures%2C%20soft%20shadows%2C%20rustic%20elegance%2C%20editorial%20style',
  },
  {
    slug: 'travel',
    name: '旅行',
    icon: 'ri-earth-line',
    description: '跟随镜头环游世界，感受各地风土人情',
    imageQuery: 'breathtaking%20mountain%20landscape%20at%20sunrise%2C%20golden%20hour%20light%2C%20winding%20road%20through%20hills%2C%20atmospheric%20fog%2C%20warm%20earthy%20tones%2C%20travel%20photography%2C%20cinematic%20composition',
  },
  {
    slug: 'tech',
    name: '科技',
    icon: 'ri-smartphone-line',
    description: '前沿科技资讯，数码产品深度评测',
    imageQuery: 'sleek%20modern%20tech%20workspace%20with%20minimalist%20design%2C%20warm%20ambient%20lighting%2C%20clean%20white%20and%20wood%20aesthetic%2C%20soft%20shadows%2C%20product%20photography%20style%2C%20professional%20setup',
  },
  {
    slug: 'fashion',
    name: '时尚',
    icon: 'ri-t-shirt-line',
    description: '潮流穿搭指南，时尚灵感每日更新',
    imageQuery: 'elegant%20fashion%20editorial%20with%20neutral%20beige%20and%20cream%20tones%2C%20natural%20lighting%2C%20minimalist%20studio%20setting%2C%20flowing%20fabrics%2C%20soft%20shadows%2C%20artistic%20composition%2C%20high-end%20aesthetic',
  },
];

export const categoryTabs = [
  { slug: 'all', name: '全部' },
  { slug: 'lifestyle', name: '生活' },
  { slug: 'entertainment', name: '娱乐' },
  { slug: 'food', name: '美食' },
  { slug: 'travel', name: '旅行' },
  { slug: 'tech', name: '科技' },
  { slug: 'fashion', name: '时尚' },
];